import {
  WidgetWindowChannel,
  WidgetWindowMessage,
} from "../../../services/widget-window.messages";

export interface WidgetWindowHost {
  close(): void;
  focus(): void;
  addEventListener(type: "pagehide", listener: () => void): void;
  removeEventListener(type: "pagehide", listener: () => void): void;
}

export class WidgetWindowClient {
  private announced = false;
  private readonly onPageHide = (): void => {
    this.channel.postMessage({ type: "bye", widgetId: this.widgetId });
  };

  constructor(
    private readonly widgetId: string,
    private readonly channel: WidgetWindowChannel,
    private readonly host: WidgetWindowHost,
  ) {
    this.channel.addEventListener("message", (event: MessageEvent<WidgetWindowMessage>) =>
      this.handle(event.data),
    );
    this.host.addEventListener("pagehide", this.onPageHide);
  }

  announce(): void {
    this.announced = true;
    this.channel.postMessage({ type: "hello", widgetId: this.widgetId });
  }

  dispose(): void {
    this.host.removeEventListener("pagehide", this.onPageHide);
    this.channel.close();
  }

  private handle(message: WidgetWindowMessage): void {
    if (message.type === "who-is-there") {
      if (this.announced) {
        this.announce();
      }
      return;
    }
    if (message.widgetId !== this.widgetId) {
      return;
    }
    if (message.type === "close") {
      this.host.close();
    } else if (message.type === "focus") {
      this.host.focus();
    }
  }
}
